
import EditModule from "@/components/ModuleEdit.vue";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			module: ModuleService.modules.find(m => m.id == parseInt(this.$route.params.id)) as Module
		};
	},
	methods: {
		async save() {
			await ModuleService.updateModule(this.module);
			this.$router.push("/modules");
		}
	},
	components: {
		EditModule
	}
});
